export const REFERRAL_EYEBROW = "Edge referral program";

export const REFERRAL_HEADING_LINES = ["Refer a business.", "Earn $2,000."];

export const REFERRAL_BODY_LINES = ["Earn $2000 for every referral that signs.", "Your referee gets $2000 too."];

export const REFERRAL_FOOTNOTE = "Visit the “Refer a business” page after logging in, to find out more.";
